module.exports = __webpack_public_path__ + "img/arrow-up-black.f1530362.svg";